import { addDoc, collection, getDocs, limit, orderBy, query } from 'firebase/firestore';
import { firestore } from '../firebaseConfig';
import { planCompanyRecord } from './intelligenceLog';

/**
 * Append one research run to the contact's Company Record.
 * The contact fields stay the latest snapshot. This log is the history.
 * Errors are swallowed so a rules or network miss never fails the research save.
 */
export async function recordCompanyRecord(userId, contactId, source, beforeContact, afterContact, capturedAt) {
  if (!userId || !contactId || !source) return;
  const colRef = collection(firestore, `World/${userId}/db/${contactId}/intelligenceLog`);
  let alreadyLogged = false;
  let latestEvent = null;
  try {
    const snap = await getDocs(query(colRef, orderBy('capturedAt', 'desc'), limit(40)));
    snap.forEach((docSnap) => {
      const data = docSnap.data();
      if (!data || data.source !== source) return;
      if (!alreadyLogged) latestEvent = data;
      alreadyLogged = true;
    });
  } catch (err) {
    console.warn('[company-record] history read skipped:', err?.message || err);
  }

  const events = planCompanyRecord({
    source,
    beforeContact,
    afterContact,
    alreadyLogged,
    latestEvent,
    capturedAt,
  });
  for (const event of events) {
    try {
      await addDoc(colRef, event);
    } catch (err) {
      console.warn('[company-record] write skipped:', err?.message || err);
    }
  }
}
